export class FilterSignature {
    description!: string;
}